import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            ci_boss_name: '',
            ci_policy_name: '',
            ci_policy_email: '',
            ci_tel: '',
            ci_fax: '',
            ci_name: '',
            ci_addr: '',
            ci_business_regi: '',
            ci_comm_regi: '',
            ci_corp_regi: '',
            ci_online_regi: '',
            terms: '',
            siteLogo: [],
            UploadFlag: '',
            deleteSiteLogo: []
        }
    },
    validators: {
        ci_boss_name: function (value) {
            return Validator.value(value)
                .required('대표자명을 입력해주세요.')
        },
        ci_policy_name: function (value) {
            return Validator.value(value)
                .required('개인정보 관리책임자명을 입력해주세요.')
        },
        ci_policy_email: function (value) {
            return Validator.value(value)
                .required('개인정보 관리책임자 이메일을 입력해주세요.')
                .email('E-mail 형식을 다시 확인해주세요.');
        },
        ci_tel: function (value) {
            return Validator.value(value)
                .required('대표번호를 입력해주세요.')
        },
        ci_fax: function (value) {
            return Validator.value(value)
                .required('팩스번호를 입력해주세요.')
        },
        ci_name: function (value) {
            return Validator.value(value)
                .required('회사명을 입력해주세요.')
        },
        ci_addr: function (value) {
            return Validator.value(value)
                .required('회사주소를 입력해주세요.')
        },
        ci_business_regi: function (value) {
            return Validator.value(value)
                .required('사업자 등록번호를 입력해주세요.')
        },
        ci_comm_regi: function (value) {
            return Validator.value(value)
        },
        ci_corp_regi: function (value) {
            return Validator.value(value)
        },
        ci_online_regi: function (value) {
            return Validator.value(value)
                .required('통신판매업 번호를 입력해주세요.')
        },
        terms: function (value) {
            return Validator.value(value)
                .required('약관정보를 입력해주세요.')
                .custom(
                    () => {
                        let content = value.replace(/<(\/p|br|p)([^>]*)>/gi, "");
                        if (content.length === 0) {
                            return '약관정보를 입력해주세요.';
                        }
                    });
        },
        siteLogo: function (value) {
            return Validator.value(value)
                .required('파일을 등록해주세요.')
        },
    },
    methods: {},
    computed: {}
}